export default __webpack_public_path__ + "static/hcp-img-a325b148a3e3f4e0d3fd8484fde2cc13.png";